// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__27JtN","text":"SelectPayment_text__jLxcj","title":"SelectPayment_title__3aJCu","btn":"SelectPayment_btn__1LZwU"};